
import { defineComponent, ref } from 'vue';
import PsModal from '@/components/core/modals/PsModal.vue';
import PsLabel from '@/components/core/label/PsLabel.vue';
import PsButton from '@/components/core/buttons/PsButton.vue';
// import PsRouteLink from '@/components/core/link/PsRouteLink.vue';
// import CreditCardModal from '@/components/modules/credit/CreditCardModal.vue';
import { PsValueProvider } from "@/store/modules/core/PsValueProvider";
import { createGetCoinProviderState } from "@/store/modules/item/GetCoinProvider";
import store from '@/store';

export default defineComponent({
    name: 'UserSettingModal',
    components: {
        PsModal,
        PsLabel,
        PsButton,
    },
    setup() {
        const psmodal = ref();
        const message = ref("Loading the data ....");
        const confirm_modal = ref();
        const credit_card_modal = ref();
        const password_update_modal = ref();
        const ps_confirm_dialog = ref();
        const psloading = ref();

        // Get Login User Id
        const psValueHolder = PsValueProvider.psValueHolder;
        const getCoinProvider = createGetCoinProviderState();
        const LoginUserId = psValueHolder.getLoginUserId();
        const coinData = ref({
            BuyCoin : 0
        })
        //Inject Provider
        function AgreeClicked(){
            localStorage.removeItem("desclimber")
            localStorage.setItem("desclimber","true")
            store.commit('desclimber', true)
            psmodal.value.toggle(false);
        }
        function openModal() {
            psmodal.value.toggle(true);
        }
       
        function closeModal() {
            psmodal.value.toggle(false);
        }

        function setMessage(messageStr) {
            message.value = messageStr;
        }

        return {
            psmodal,
            openModal,
            closeModal,
            message,
            setMessage,
            credit_card_modal,
            AgreeClicked,
            password_update_modal,
            ps_confirm_dialog,
            psloading,
            confirm_modal,
            LoginUserId,
            psValueHolder,
            coinData,
            getCoinProvider
        }
    },
})
